import React from 'react';
import ReactDOM from 'react-dom';
import Corepage from './../../views/core/CorePage';
import HmEventRegistry from './../../model/HmEventRegistry';
import AssetModel from './../../model/AssetModel';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactHtmlParser from 'react-html-parser';
import { Label } from 'reactstrap';

class ContestQuesAlert extends Corepage {

	constructor(props){
		super(props);
        this.state={
            acceptOk:true
        }
        //this.instantKill = this.instantKill.bind(this);		
        this.acceptOKFn = this.acceptOKFn.bind(this);
        this.checkFn = this.checkFn.bind(this);
	}

	instantKill(){
		if(document.getElementById('subroot').innerHTML && document.getElementById('subroot').innerHTML.length > 0){
			ReactDOM.unmountComponentAtNode(document.getElementById('subroot'));
        }	
    }
    
    acceptOKFn(e){
       if(!this.state.acceptOk){
        if(typeof this.props.callBack === "function"){
            this.props.callBack();
        }
       }
    }

    checkFn(){
        this.setState({
            acceptOk:!this.state.acceptOk
        });
    }

	showQuestnAlertPrompt(){
        let me=this;
        var testType = this.props.type || "round1";
		var title = this.rb("contest.title.quesAlert_"+testType);
		var msg = this.rb("contest.test.quesAlert_"+testType);
		// var msg1 = "Message"; //this.rb("label.net.msg1");
		let activated = this.state.acceptOk ? "disabled":"";
		const styles={
			float:"right",
			cursor:"pointer"
		}
		return (
            <div id="networkcheck" className='custom-ui-alert'>
            <div className="row">

            <div className="col-sm-12 col-xs-5 col-md-5 col-lg-5 img_sec nopadding">
            <img src='/images/contest/outsideschool.png' />
            </div>

            <div className="col-sm-12 col-xs-6 col-md-6 col-lg-6 conttestquesinfo">

            <div>
            <h1>{title}</h1>
            </div>

            {ReactHtmlParser(msg)}
            <div className="alertcheckbox">
            <Label><input type="checkbox" onClick={this.checkFn}></input>{this.rb("contest.test.quesAlert.check")}</Label>
            </div>
            <div class="react-confirm-alert-button-group">
                <button onClick={this.acceptOKFn} className={"chkbtn "+activated} disabled={this.state.acceptOk}>{this.rb("btn.ok")}</button>
            </div>

            </div>

            </div>

            </div>
            )
        }

	render() {
		let me = this;
		return(
			<div id="contpopup">
			<div className="container text-center ">

			{this.showQuestnAlertPrompt()}

			</div>
			</div>
			);
	}
}

export default ContestQuesAlert;


// HmEventRegistry.registerEvent("CONTEST_QUESTIONALERT", function(obj){
// 	ReactDOM.render(<ContestQuesAlert callBack={obj.callBack} type={obj.type} />, document.getElementById('subroot'));	
// });


// WEBPACK FOOTER //
// ./src/components/common/ContestQuesAlert.js